import { LogoMark } from "../../../components/brand/Logo";

const NAV = ["Dashboard", "Transactions", "Receipts", "Reports", "Policies", "Settings"];
const METRICS = [
  { label: "Total receipts", value: "1,842", delta: "+12%" },
  { label: "Missing docs",   value: "3",     delta: "-8"   },
  { label: "AI categorized", value: "99.8%", delta: "↑"    },
];
const ROWS = [
  { merchant: "Delta Airlines", amount: "$428.00",   category: "Travel",   status: "Verified" },
  { merchant: "Notion",         amount: "$16.00",    category: "Software", status: "Verified" },
  { merchant: "Whole Foods",    amount: "$94.23",    category: "Meals",    status: "Pending"  },
  { merchant: "AWS",            amount: "$1,204.50", category: "Hosting",  status: "Verified" },
];

export function DashPanel() {
  return (
    <div className="flex h-full overflow-hidden">
      {/* Sidebar — hidden on narrow panels */}
      <div className="hidden sm:flex w-44 shrink-0 bg-[var(--ink-950)] flex-col px-4 py-5 gap-1">
        <div className="flex items-center gap-2 mb-6">
          <LogoMark variant="on-dark" size={20} aria-hidden="true" />
          <span className="text-sm font-semibold text-white">Proofly</span>
        </div>
        {NAV.map((item, i) => (
          <div
            key={item}
            className={[
              "px-3 py-1.5 rounded-lg text-sm",
              i === 0 ? "bg-[var(--sidebar-accent)] text-white font-medium" : "text-white/60",
            ].join(" ")}
          >
            {item}
          </div>
        ))}
      </div>

      {/* Main */}
      <div className="flex-1 overflow-auto p-4 bg-[var(--ink-50)]">
        {/* Header */}
        <div className="flex items-start justify-between mb-4">
          <div>
            <div className="text-[10px] uppercase tracking-widest text-[var(--ink-500)] mb-0.5">
              Fiscal Year 2024
            </div>
            <h3 className="text-base font-semibold text-[var(--ink-950)] leading-tight">
              Audit Dashboard
            </h3>
          </div>
          <div className="flex gap-1.5 shrink-0">
            <span className="text-[11px] font-semibold bg-[var(--success-50)] text-[var(--success)] px-2 py-0.5 rounded-full whitespace-nowrap">
              ● 96
            </span>
            <span className="text-[11px] font-semibold border border-[var(--ink-200)] px-2 py-0.5 rounded-full text-[var(--ink-700)]">
              Export
            </span>
          </div>
        </div>

        {/* Metrics */}
        <div className="grid grid-cols-3 gap-2 mb-4">
          {METRICS.map((m) => (
            <div key={m.label} className="p-2.5 rounded-xl border border-[var(--ink-200)] bg-white">
              <div className="text-[10px] text-[var(--ink-500)] mb-1 leading-tight">{m.label}</div>
              <div className="text-lg font-semibold text-[var(--ink-950)] leading-none mb-0.5">
                {m.value}
              </div>
              <div className="text-[10px] font-semibold text-[var(--success)]">{m.delta}</div>
            </div>
          ))}
        </div>

        {/* Table */}
        <div className="text-[10px] font-semibold text-[var(--ink-500)] uppercase tracking-wide mb-1.5">
          Recent Transactions
        </div>
        <div className="rounded-xl border border-[var(--ink-200)] bg-white overflow-hidden">
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-[var(--ink-200)] text-[var(--ink-400)]">
                <th className="text-left px-3 py-1.5 font-medium">Merchant</th>
                <th className="text-right px-3 py-1.5 font-medium">Amt</th>
                <th className="text-left px-3 py-1.5 font-medium">Status</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r) => (
                <tr key={r.merchant} className="border-b last:border-0 border-[var(--ink-100)]">
                  <td className="px-3 py-2 font-medium text-[var(--ink-950)] truncate max-w-[90px]">
                    {r.merchant}
                  </td>
                  <td className="px-3 py-2 text-right text-[var(--ink-600)] whitespace-nowrap">
                    {r.amount}
                  </td>
                  <td className="px-3 py-2">
                    <span
                      className={[
                        "text-[10px] font-semibold px-1.5 py-0.5 rounded-full",
                        r.status === "Verified"
                          ? "bg-[var(--success-50)] text-[var(--success)]"
                          : "bg-[var(--warning-50)] text-[var(--warning)]",
                      ].join(" ")}
                    >
                      {r.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
